



<template>
  <div class="page">
    <van-nav-bar title="我的课程" left-arrow @click-left="onClickLeft" />
    <div class="card">
      <table class="course-table" border cellspacing="0">
        <thead>
          <tr>
            <th>序号</th>
            <th>学习模块</th>
            <th>课程名称</th>
            <th>学分</th>
            <th>考试方式</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in courseList" :key="item.courseId ">
            <td>{{ index + 1 }}</td>
            <td>{{ item.courseTypeName || '--' }}</td>
            <td class="name">{{ item.coursesName || '--' }}</td>
            <td>{{ item.credit || '--' }}</td>
            <td>{{ item.studyTypeName || '--' }}</td>
          </tr>
          <tr v-if="!loading && courseList.length === 0">
            <td colspan="5" class="empty">暂无课程数据</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getMyCourseList } from '@/api/login';

export default {
  name: 'myCourse',
  data() {
    return {
      courseList: [],
      loading: false,
    };
  },
  created() {

    this.fetchCourseList();
  },
  methods: {
    fetchCourseList() {
      this.loading = true;
      getMyCourseList()
        .then((res) => {
          this.courseList = res || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #f9f9f9;
  padding-bottom: 20px;
}

.card {
  margin: 12px 10px 0;
  background-color: #fff;
  border-radius: 12px;
  padding: 10px 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.course-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #333;
}

.course-table th,
.course-table td {
  border: 1px solid #e6e6e6;
  padding: 8px 6px;
  text-align: center;
  line-height: 1.4;
}

.course-table thead th {
  background: #f2f2f2;
  font-weight: 600;
}

.course-table .name {
  text-align: left;
  padding-left: 10px;
}

.empty {
  color: #999;
  padding: 16px 0;
}
</style>